import { useCallback, useEffect, useMemo, useState } from "react";
import copy from "copy-to-clipboard";
import { useAuthSelector } from "../../redux/reducers/AuthReducer/AuthReducer";
import { useScopesSelector } from "../../redux/reducers/ScopesReducer/ScopesReducer";
import { useScopesService } from "../../services/ScopesService/ScopesService";
import { getAdminConsentUrl } from "./Consent.const";
const COPIED_FEEDBACK_MS = 2500;
export const useConsentLogic = () => {
    const { isTeamsApp } = useAuthSelector("isTeamsApp");
    const { teamsFxConfig, needToConsent, isConsenting, isFinishing, consentFailed } = useScopesSelector("teamsFxConfig", "needToConsent", "isConsenting", "isFinishing", "consentFailed");
    const { consent } = useScopesService();
    // Unfolded by default after a failed attempt (the admin route is the likely way out),
    // until the user toggles it themselves.
    const [isAdminHelpToggled, setIsAdminHelpToggled] = useState(undefined);
    const [isLinkCopied, setIsLinkCopied] = useState(false);
    const adminConsentUrl = useMemo(() => getAdminConsentUrl(teamsFxConfig?.tenantId, teamsFxConfig?.clientId ?? ""), [teamsFxConfig?.tenantId, teamsFxConfig?.clientId]);
    useEffect(() => {
        if (!isLinkCopied)
            return;
        const timer = setTimeout(() => setIsLinkCopied(false), COPIED_FEEDBACK_MS);
        return () => clearTimeout(timer);
    }, [isLinkCopied]);
    const isAdminHelpOpen = isAdminHelpToggled ?? consentFailed;
    const toggleAdminHelp = useCallback(() => setIsAdminHelpToggled(!isAdminHelpOpen), [isAdminHelpOpen]);
    // copy-to-clipboard falls back to execCommand, which still works where the Teams iframe
    // blocks navigator.clipboard.
    const copyAdminLink = useCallback(() => setIsLinkCopied(copy(adminConsentUrl)), [adminConsentUrl]);
    return {
        isReady: !!teamsFxConfig && needToConsent,
        isTeamsApp,
        customTitle: teamsFxConfig?.loginPageTitle,
        customSubtitle: teamsFxConfig?.loginPageSubtitle,
        isConsenting,
        isFinishing,
        isBusy: isConsenting || isFinishing,
        consentFailed,
        isAdminHelpOpen,
        adminConsentUrl,
        isLinkCopied,
        consent,
        toggleAdminHelp,
        copyAdminLink,
    };
};
